module.exports = __webpack_public_path__ + "assets/img/t-1.7edd4f3a.gif";